import {atom} from "recoil";
import keys from "configs/atoms";

const lookupCurrencyAtom = atom(({
    key: keys.Lookup.Currency,
    default: ["AUD", "USD", "EUR", "GBP", "JPY", "CHF", "CAD", "NZD", "CNY", "HKD", "SGD", "THB"]
}));

export default lookupCurrencyAtom;